import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-4\"><label class=\"block mb-2\"> Ваше Имя </label><input type=\"text\" class=\"block w-full max-w-lg rounded\"></div><div class=\"mb-4\"><label class=\"block mb-2\"> Ваш E-mail </label><input type=\"email\" class=\"block w-full max-w-lg rounded\"></div><div class=\"mb-4\"><label class=\"block mb-2\"> Ваше Имя </label><input type=\"text\" class=\"block w-full max-w-lg rounded\"></div><div class=\"mb-4\"><label class=\"block mb-2\"> Ваш Телефон </label><input type=\"tel\" class=\"block w-full max-w-lg rounded\"></div><div class=\"mb-5\"><label class=\"block mb-2\"> Ваше Сообщение </label><textarea class=\"block w-full max-w-xl rounded\"></textarea></div>", 5)
const _hoisted_6 = { class: "flex gap-2 items-center mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  class: "w-6 h-6 text-teal-400 rounded"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Согласие с ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" политикой конфиденциальности ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "grid lg:block" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "inline-block py-3 px-6 text-lg font-bold text-zinc-100 bg-teal-500 rounded"
  }, " Отправить ")
], -1)

import AppPageTitle from './AppPageTitle.vue';
import { setTitle } from '../title';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

setTitle('Контакты');


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageTitle, { title: 'Контакты' }),
    _hoisted_1,
    _createElementVNode("label", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("span", null, [
        _hoisted_8,
        _createVNode(_component_router_link, {
          to: "/privacy-policy",
          class: "text-teal-600"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_10
  ], 64))
}
}

})